import { profile } from "@/data/resume";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[color:var(--border)] py-10 bg-[color:var(--linen-2)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm font-mono-editorial text-[color:var(--muted)] uppercase tracking-[0.15em]">
        <span>© {year} — {profile.name}</span>
        <span>Built with an AI agent · Mumbai, IN</span>
        <a href={profile.linkedin} target="_blank" rel="noreferrer" className="editorial-link hover:text-[color:var(--accent)]">LinkedIn ↗</a>
      </div>
    </footer>
  );
}
